// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.breadcrumb[data-v-5fc8daf8] {\n  text-align: left;\n  margin-bottom: 16px;\n  /* background-color: white; */\n}\n", ""]);
// Exports
module.exports = exports;
